import * as React from "react";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";

import MyTabbedLayout from "../mui/TabbedLayout";

import ApprovedTable from "./ApprovedKitchen";
import NewApplicants from "./NewApplicants";
import KitchenProfileView from "./ViewKitchen";
import ProgressDialog from "../mui/progressdialog";
import AlertDialog from "../mui/dialog";
import { loadAllKitchens } from "../data/API";

export const TITLE_HOME = "Kitchens";
export const TITLE_NEW_APPLICANTS = TITLE_HOME + " > Applicants";
export const TITLE_REVIEW = TITLE_NEW_APPLICANTS + " > Review";
export const TITLE_APPROVED = TITLE_HOME + " > Approved";
export const TITLE_VIEW = TITLE_APPROVED + " > View";

export default function Kitchen() {
  const [selectedApplicantData, setSelectedApplicantData] =
    React.useState(null);
  const [state, setState] = React.useState(TITLE_APPROVED);
  const [kitchensList, setKitchensList] = React.useState(null);

  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);



  const onBackClickListener = () => {
    if (state !== TITLE_HOME) {
      if (state === TITLE_VIEW) {
        setState(TITLE_APPROVED);
      } else if (state === TITLE_REVIEW) {
        setState(TITLE_APPROVED);
        setCount(0);
      }
    }
  };

  const onApplicantSelection = (applicant) => {
    setSelectedApplicantData(applicant);
    setState(TITLE_REVIEW);
    console.log(applicant);
  };


  const [count, setCount] = React.useState(0);

  function loadData(){
    setIsLoading(true)
    setIsWarning(false)
    if(count===0){
      // console.log('called:loadData'+count);
      setCount(count+1);
      loadAllKitchens((err,data)=>{
        if(err){
          setIsWarning(true);
          setIsLoading(false);
          console.log(err);
        }else{
          setKitchensList(data);
          setIsLoading(false);
          setIsWarning(false);
        }
      })
    }
  }


  if(count===0){
    loadData();
  }




  return (
    <div>
      <ProgressDialog msg={"Loading Kitchens"} visible={isLoading} />
        <AlertDialog
          warningMessage={
            "Something went wrong! please refresh page or connect with internet"
          }
          visible={isWarning}
        />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            borderRadius: "10px",
            padding: 8,
            background: "red",
            display: "inline-flex",
            flexDirection: "row",
            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          <HomeIcon
            onClick={() => {
              if (state !== TITLE_APPROVED && state !== TITLE_NEW_APPLICANTS)
                setState(TITLE_APPROVED);
                setCount(0);
            }}
            sx={{
              color: "white",
              alignSelf: "center",
              marginInlineEnd: 1,
            }}
          />
          {state !== TITLE_APPROVED && state != TITLE_NEW_APPLICANTS ? (
            <ArrowBackIosIcon
              onClick={onBackClickListener}
              sx={{
                color: "white",
                alignSelf: "center",
                marginInlineEnd: 1,
                marginInlineStart: 1,
              }}
            />
          ) : (
            ""
          )}
          <h1
            style={{
              color: "rgb(255, 255, 255)",
              fontSize: 20,
            }}
          >
            {state}
          </h1>
        </div>
      </div>
      <div style={
        {
          width: "100%",
          height: window.innerHeight-100,
          overflowY:'auto'
        }
      }>
        {state === TITLE_APPROVED || state === TITLE_NEW_APPLICANTS ? (
          <MyTabbedLayout
            defaultSelection={state === TITLE_APPROVED ? 0 : 1}
            onSelection={(value) => {
              if (value === 0) setState(TITLE_APPROVED);
              else setState(TITLE_NEW_APPLICANTS);
            }}
            tabs={[
              { title: "Approved", element: <ApprovedTable onKitchenSelection={onApplicantSelection} data = {kitchensList?.approved}/> },
              {
                title: "New Applicants",
                element: (
                  <NewApplicants data={kitchensList?.others} onApplicantSelection={onApplicantSelection} />
                ),
              },
            ]}
          />
        ) : state === TITLE_REVIEW || state === TITLE_VIEW ? (
          <KitchenProfileView setLoading={setIsLoading} setWarning={setIsWarning} data={selectedApplicantData}/>
        ) : null}
      </div>
    </div>
  );
}
